import { render, staticRenderFns } from "./EmailDialogChangeType.vue?vue&type=template&id=cbd8156c"
import script from "./EmailDialogChangeType.ts?vue&type=script&lang=ts&external"
export * from "./EmailDialogChangeType.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports